module.exports = __webpack_public_path__ + "b4ab54e82cb99ced61d8a9e5d2598a9e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/circle_a_new_kind_of_buy.png
// module id = 175
// module chunks = 0